import { withRouter, Link } from "react-router-dom"
import React, {useEffect, useState} from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip, Badge,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport,Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import { LargeModal } from "components/Common/LargeModal"
import * as moment from "moment"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import TableLoader from "../../../components/Common/TableLoader";

function Table(props) {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalsData] = useState([])

  const _renderOddName = (f, odd) => {
    if (odd?.player) {
      return odd?.player?.name;
    }
    let text = odd?.market_spec?.name ?? "";

    text = text.replaceAll("{$competitor1}", f?.competitors[0]?.name);
    text = text.replaceAll("{$competitor2}", f?.competitors[1]?.name);
    if(text.includes('{total}')){
      text = text.replaceAll("{total}",odd?.special_bet_value);
    }
    else{
      if(odd?.special_bet_value){
        text = text + ` {${odd?.special_bet_value}}`
      }
    }

    return text;
  };

  let { data } = props
  useEffect(() => {
    let modalDatas= props.modelData;
    if(modalDatas){
      // console.log(modalDatas.bets)
      setModalsData(modalDatas);
    }
  }, [props.modelData]);
  data = data.sort((a, b) =>
      moment(a.created_at, "DD-MM-YYYY").isBefore(
          moment(b.created_at, "DD-MM-YYYY")
      )
          ? 1
          : -1
  )

  // console.log(data)

  const optionsLive = [
    { label: "prematch", value: "Prematch" },
    { label: "live", value: "Live" },
  ]

  useEffect(() => {
    props.call()
  }, [props.liveData])
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "booking_id",
      text: "Booking ID",
      sort: true,
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row.channel == "Online" ? row.user.phone_number : row.user.username}
        </>
      ),
    },
    {
      dataField: "channel",
      text: "Channel",
      sort: true,
      formatter: (cell, row) => <>{row.channel ?? "Online"}</>,
    },
    {
      dataField: "betType",
      text: "Bet Type",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row.bets?.length == 1 ? "Single" : `Multiple(${row.bets?.length})`}
        </>
      ),
    },
    {
      dataField: "created_at",
      text: "Date Time",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "stake",
      text: "Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{parseFloat(Number(row.stake).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "stake_after_tax",
      text: "Stake Tax",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(
            parseFloat(row.stake - row.stake_after_tax).toFixed(2)
          ).toLocaleString("en-GB")}
        </>
      ),
    },
    {
      dataField: "stake_after_tax",
      text: "Actual Stake",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row.stake_after_tax).toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
    // {
    //   dataField: "accept_odds_change",
    //   text: "Accept Odds Change",
    //   sort: true,
    // },
    {
      dataField: "bonus_amount",
      text: "Bonus",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.bonus_amount ?? 0).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row.wht).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "to_win",
      text: "NetWin",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row.to_win).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "status",
      text: "Bet Status",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row.status == 1
            ? "won"
            : row.status == 0
            ? "lost"
            : row.status == 2
            ? "void"
            : "pending"}
        </>
      ),

      // eslint-disable-next-line react/display-name
      // formatter: (cellContent, row) => (
      //   <div className="text-body fw-bold">{row.BetStatus}</div>
      // ),
    },
    // {
    //   dataField: "total_odds",
    //   text: "Total Odds",
    //   sort: true,
    // },

    // {
    //   dataField: "excise_tax",
    //   text: "Excise Tax",
    //   sort: true,
    // },

    {
      dataField: "view",
      isDummyField: true,
      text: "Action",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <Row>
            {/* <Col lg={5}>
              <Button type="button" color="primary" className="btn-sm">
                Refund
              </Button>
            </Col> */}
            <Col lg={5}>
              <Button type="button" color="primary" className="btn-sm">
                Details
              </Button>
            </Col>
            {/*{row.status == null ?*/}
            {/*    <Col lg={5}>*/}
            {/*      {new Date().getTime() < new Date(new Date(parseInt(row?.bets[0]?.odd?.fixture_market?.fixture?.match_date?.$date?.$numberLong))).getTime() ?*/}
            {/*          <Button type="button" color="danger" className="btn-sm" id="btn-cancel"*/}
            {/*                  onClick={() => {*/}
            {/*                    props.cancelTicketCall(row.id)*/}
            {/*                  }}*/}
            {/*          >*/}
            {/*            Cancel*/}
            {/*          </Button>*/}
            {/*          : ''*/}
            {/*      }*/}
            {/*    </Col>:''*/}
            {/*}*/}
            <Col lg={2}></Col>
          </Row>
        </>
      ),
    },
  ]
  const modalColumns = [
    {
      dataField: "created_at",
      text: "Time",
      sort: true,
      formatter: (cell1, row1) => (
          <>{new Date(parseInt(row1.odd?.fixture_market?.fixture?.match_date?.$date?.$numberLong)).toLocaleString('en-GB', {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}</>
      ),
    },
    {
      dataField: "channel",
      text: "Event",
      sort: true,
      formatter: (cell1, row1) => (
          <>
            {row1.odd?row1.odd.fixture_market.fixture.tournament.sport.name:""}
            <i className="mdi mdi-information font-size-18" id={`addtooltip${row1?.id}`} />
            <UncontrolledTooltip placement="right" target={`addtooltip${row1?.id}`} style={{'width':'100%'}}>
              <p style={{'margin-bottom':'0px','text-align':'left'}}>Sport: {row1.odd?row1.odd.fixture_market.fixture.tournament.sport.name:""}</p>
              <p style={{'margin-bottom':'0px','text-align':'left'}}>Location: {row1.odd?row1.odd.fixture_market.fixture.tournament.category.name:""}</p>
              <p style={{'margin-bottom':'0px','text-align':'left'}}>League: {row1.odd?row1.odd.fixture_market.fixture.tournament.name:""}</p>
              <p style={{'margin-bottom':'0px','text-align':'left'}}>Event: {row1.odd?row1.odd.fixture_market.fixture.competitors[0].name+' vs':""} {row1.odd?row1.odd.fixture_market.fixture.competitors[1].name:""}</p>
            </UncontrolledTooltip>
          </>
      ),
    },
    {
      dataField: "is_live",
      text: "Type",
      sort: true,
      formatter: (cell1, row1) => (

          <>{(props.liveData=="live")?"Live":"Pre-Match"}</>
      ),
    },
    {
      dataField: "odd.fixture_market.fixture_bb_id",
      text: "MatchID",
      sort: true,
      formatter: (cell1, row1) => (

          <>{row1?.odd?.fixture_market?.fixture_bb_id}</>
      ),
    },
    {
      dataField: "channel",
      text: "Fixture",
      sort: true,
      formatter: (cell1, row1) => (
          <>{row1.odd?row1?.odd?.fixture_market?.fixture?.competitors[0]?.name+' vs':""}  {row1.odd?row1?.odd?.fixture_market?.fixture?.competitors[1]?.name:""}</>
      ),
    },
    {
      dataField: "price",
      text: "Odds",
      sort: true,
      formatter: (cell1, row1) => (
          <>{row1?.price.toFixed(2)}</>
      ),
    },
    {
      dataField: "test",
      text: "Selection",
      sort: true,
      formatter: (cell1, row1) => (
          <>
            {(row1?.odd?.length != 0 && row1?.odd!=null)
                ?
                _renderOddName(
                    row1?.odd?.fixture_market?.fixture,
                    row1?.odd
                ) : ''
            }
            <i className="mdi mdi-information font-size-18" id={`addtooltip2${row1?.id}`} />
            <UncontrolledTooltip placement="top" target={`addtooltip2${row1?.id}`}>
              <p style={{'margin-bottom':'0px'}}>Market: {row1.odd?row1.odd.fixture_market.market.name:""}</p>
            </UncontrolledTooltip>


          </>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell1, row1) => (
          <>
            <Button
                type="button"
                color=
                    {
                      (row1?.is_cancel_by_admin) ? "info" :
                      (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled==null && row1.is_won==null) ? 'info' :
                        (row1?.status) ? "success" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "secondary" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "primary" : ((row1?.is_won) ? "success" : "danger")))
                    }
                className="btn-sm"
            >
              {
                (row1?.is_cancel_by_admin) ? "Void" :
                (row1?.status == null && parseFloat(row1?.void_factor) == parseFloat(0) && row1.out_come_for_canceled==null && row1.is_won==null) ? 'Pending' :

                  (row1?.status) ? "Won" : ((row1?.out_come_for_canceled == 'N' || row1?.out_come_for_canceled == 'C') ? "Cancel" : ((parseFloat(row1?.void_factor) != parseFloat(0)) ? "Void" : ((row1?.is_won) ? "Won" : "Lost")))
              }

            </Button>
          </>
      ),
    },
  ]
  const cardsData = [
    {
      color: "primary",
      fontColor: "text-white",
      title: "Total Stake",
      description: modalData.stake?parseFloat(modalData.stake).toFixed(2):0,
      borderClass: "",
    },
    {
      color: "success",
      fontColor: "text-white",
      title: "Effective Stake",
      description: modalData.stake_after_tax?parseFloat(modalData.stake_after_tax).toFixed(2): 0,
      borderClass: "",
    },
    {
      color: "info",
      fontColor: "text-white",
      title: "Boost",
      description: modalData.bonus_amount?parseFloat(modalData.bonus_amount).toFixed(2):0,
      borderClass: "",
    },
    {
      color: "warning",
      fontColor: "text-dark",
      title: "Possible Win",
      description: modalData.to_win?modalData.to_win:0,
      borderClass: "",
    },
  ]



  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { SearchBar } = Search
  //pagination customization
  const { ExportCSVButton } = CSVExport;

  const pageOptions = {
    sizePerPage: 20,
    totalSize: data.length,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if(e.target.id!="btn-cancel"){
        props.callById(row.id)
        setIsOpen(true);
      }
    },
  }
  return (
      <>
        <Card>
          <CardBody>
            <div className="mb-4 h4 card-title">{"Book-A-Bet Tickets"}</div>
            {
              (props.loadingMessage && props.loadingMessage == "1") ?
                  <TableLoader/> :

                  <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={data}
                  >
                    {({paginationProps, paginationTableProps}) => (
                        <ToolkitProvider
                            keyField="id"
                            data={data}
                            columns={columns}
                            bootstrap4
                            search
                            exportCSV={ { onlyExportFiltered: true, exportAll: false, fileName: `Sports-Report-${moment(new Date()).format("DD/MM/YYYY")}.csv`}}
                        >
                          {toolkitProps => (
                              <React.Fragment>
                                <Row className="mb-2">
                                  <Col sm="6">
                                    <Row>
                                      <Col sm="6">
                                        <div className="search-box me-2 mb-2 d-inline-block">
                                          <div className="position-relative">
                                            <SearchBar {...toolkitProps.searchProps} />
                                            <i className="bx bx-search-alt search-icon"/>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col sm="6">
                                        <div>
                                          <ExportCSVButton { ...toolkitProps.csvProps } className="download-table-xls-button w-md btn btn-primary">Download</ExportCSVButton>
                                        </div>
                                      </Col>

                                    </Row>
                                  </Col>

                                </Row>
                                <Row>
                                  <Col xl="12">

                                    <div className="table-responsive">
                                      <BootstrapTable id="table-to-xls"
                                                      keyField="id"
                                                      responsive
                                                      bordered={false}
                                                      striped={false}
                                                      defaultSorted={defaultSorted}
                                          //   selectRow={selectRow}
                                                      classes={
                                                        "table align-middle table-nowrap table-check"
                                                      }
                                                      headerWrapperClasses={"table-light"}
                                                      {...toolkitProps.baseProps}
                                                      {...paginationTableProps}
                                                      rowClasses={"mytable-hover-row"}
                                                      rowEvents={rowEvents}
                                      />
                                    </div>

                                  </Col>
                                </Row>
                                {/*{console.log(paginationProps)}*/}
                                <div className="pagination pagination-rounded justify-content-end">
                                  <PaginationListStandalone {...paginationProps} />
                                </div>
                              </React.Fragment>
                          )}
                        </ToolkitProvider>
                    )}
                  </PaginationProvider>
            }
          </CardBody>
        </Card>

        {
          (Object.keys(modalData).length !== 0) ?
              <LargeModal
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  cardsData={cardsData}
                  betType={"1bet, 2-fold multiple"}
                  size={"xl"}
                  columns={modalColumns}
                  data={modalData}
              />
              : ''
        }

      </>
  )
}

export default Table
